import React from 'react';
import { Box, Grid, Text, InputGroup } from '@chakra-ui/core';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import AlgoliaPlaces from 'algolia-places-react';

import { AlgoSearch } from '../../redux/actions/searchAction';

function Search(props) {
  //   const [query, setQuery] = useState('');

  //   useEffect(() => {
  //     props.AlgoSearch(query);
  //   }, []);

  //   const handlechange = e => {
  //     e.persist();
  //     setQuery(e.target.value);
  //     // props.AlgoSearch(query)
  //   };

  //   const handelFocus = () => {
  //     box ? setbox(false) : setbox(true);
  //   };

  return (
    <Box
      width={['100%', '100%', '100%', '50%']}
      mr={props.nav && '100px'}
      position="relative"
    >
      <InputGroup>
        {/* <InputLeftElement
          ml="50px"
          children={<FaSearch style={{}} />}
        ></InputLeftElement> */}
      </InputGroup>
      {/* <Input
        h="50px"
        border="1px solid #eee"
        borderColor="#eee"
        rounded="15px"
        bg="rgba(250,250,250,0.2)"
        color="white"
        className="main-search"
        onFocus={() => setbox(true)}
        // variant="flushed"
        type="text"
        name="search-algolia"
        placeholder="Saisissez une adresse ou le nom d’un restaurant"
        onChange={handlechange}
        autoComplete="off"
      ></Input> */}
      <AlgoliaPlaces
        placeholder="Saisissez une adresse "
        options={{
          appId: process.env.REACT_APP_algoliaplaceAppKey,
          apiKey: process.env.REACT_APP_algoliaplaceSearchKey,
          language: 'fr',
          countries: ['fr', 'dz'],
          type: 'address',
          // Other options from https://community.algolia.com/places/documentation.html#options
        }}
        onChange={({ query, rawAnswer, suggestion, suggestionIndex }) => {
          props.AlgoSearch(suggestion.latlng);
          //   props.AlgoSearch('turtle');
        }}
        onSuggestions={({ rawAnswer, query, suggestions }) => {
          props.AlgoSearch('clear');
        }}
        // onCursorChanged={({ rawAnswer, query, suggestion, suggestonIndex }) =>

        // }
        onClear={() => props.AlgoSearch('clear')}
        // onLimit={({ message }) =>
        // }
        // onError={({ message }) =>

        // }
      />
      {props.search.hits && (
        <Box
          overflowY="scroll"
          rounded="10px"
          shadow="lg"
          zIndex="999"
          width="100%"
          maxH="300px"
          bg="white"
          position="absolute"
        >
          {props.search.hits.map(hit => {
            return (
              <Link key={hit.id} to={`restaurant/${hit.id}`}>
                <Box
                  //   as="Box"
                  onClick={() => props.AlgoSearch('clear')}
                  mb="1"
                  p="3"
                  shadow="20px"
                  cursor="pointer"
                  rounded="10px"
                  _hover={{ bg: 'gray.50' }}
                >
                  <Grid
                    gridTemplateColumns={[
                      ' 1fr',
                      ' 1fr',
                      '0.3fr 1fr',
                      '0.3fr 1fr',
                    ]}
                  >
                    <Box
                      style={{
                        background: `
    url('${process.env.REACT_APP_API}/storage/${hit.image}')`,
                      }}
                      className="detail-image"
                      overflow="hidden"
                      height="80px"
                      width="auto"
                    >
                      {/* <img
                        src={`${process.env.REACT_APP_API}/storage/${hit.image}`}
                        align="left"
                        alt={hit.name}
                      /> */}
                    </Box>
                    <Box pl="10px">
                      <Text fontWeight="bold" fontSize="xl" color="gray.600">
                        {hit.name}
                      </Text>
                      <Text color="gray.500">{hit.adress}</Text>
                    </Box>
                  </Grid>
                </Box>
              </Link>
            );
          })}
        </Box>
      )}
    </Box>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    AlgoSearch: query => dispatch(AlgoSearch(query)),
  };
};

const mapStateToProps = state => {
  return {
    search: state.search,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Search);
